<app-section
  titleSection="Tendances et études du marché"
  [isLargeTitle]="true"
  [onlyTitle]="true"
  [isActivated]="statistics.isEnabled"
  (enabled)="onEnabled($event)"
>
</app-section>
